import { createEvent, createStore } from 'effector'

import type { Message } from '@/modules/message/service/message-service.tsx'

export const resetFollowUpState = createEvent('follow up messages: reset state')

export const setMessages = createEvent<Message[]>('set messages')
export const addMessage = createEvent<Message>('add message')
export const updateMessage = createEvent<Message>('update message')
export const removeMessage = createEvent<{ id: Message['id'] }>(
  'remove message',
)
export const $followUpMessages = createStore<Message[]>([], {
  name: 'follow up messages list',
})
  .on(setMessages, (_, payload) => payload)
  .on(addMessage, (state, payload) => [
    ...state,
    { ...payload, id: state.length },
  ])
  .on(updateMessage, (state, payload) =>
    state.map((message) => (message.id === payload.id ? payload : message)),
  )
  .on(removeMessage, (state, { id }) =>
    state.filter((message) => message.id !== id),
  )
  .reset(resetFollowUpState)

export const setSendAfterMinutes = createEvent<number>('set send after minutes')

export const validateSendAfterMinutes = createEvent(
  'validate send after minutes',
)

export const resetSendAfterMinutesError = createEvent(
  'reset send after minutes error',
)

export const $sendAfterMinutesError = createStore<string | null>(null, {
  name: 'follow up messages: send after minutes error',
})
  .on(validateSendAfterMinutes, (_, __) => 'Value must be more than 0')
  .on(setSendAfterMinutes, (_, minutes) =>
    minutes > 0 ? null : 'Value must be more than 0',
  )
  .reset(resetFollowUpState)
  .reset(resetSendAfterMinutesError)

export const $sendAfterMinutes = createStore(0, {
  name: 'follow up messages: send after minutes',
})
  .on(setSendAfterMinutes, (_, payload) => payload)
  .reset(resetFollowUpState)

export const setSendIfNotSeenParentMessage = createEvent<boolean>(
  'set send if not seen',
)
export const $sendIfNotSeenParentMessage = createStore(false, {
  name: 'follow up messages: send if not seen',
})
  .on(setSendIfNotSeenParentMessage, (_, payload) => payload)
  .reset(resetFollowUpState)
